const d3 = require('d3')
const moment = require('moment');
const { parseDate } = require('../utils/formatters.js');
const { wrap } = require('../utils/shared-functions.js');
const { temperatureConvert } = require('../utils/converter.js');


exports.createStepsChart = (rawData, manualData, thresholds, onClick, width, height) => {
  const STEPS_POINT_COLOR = '#7CB75D';
  const STEPS_AREA_COLOR = '#9ac03a';
  const EMPTY_COLOR = '#000000';
  const BAR_WIDTH = 30;
  
  let MAX_STEP_VAL = 0;
 
  const margin = { top: 40, right: 30, bottom: 40, left: 50 };



  const parseDate = d3.utcParse('%Y-%m-%d');
  const formatChange = () => {
    const f = d3.format('+.2%');
    return (y0, y1) => f((y1 - y0) / y0);
  };

  const data = rawData.map((d) => {
    const momentFormatted = moment(d['date']).format('YYYY-MM-DD');
    const date = parseDate(momentFormatted);
    if (d['value'] > MAX_STEP_VAL) MAX_STEP_VAL = d['value']
    const obj = {
      date,
      data: d['value'],
      color: STEPS_POINT_COLOR,
    };
    return obj;
  });

  const MAX_STEPS = MAX_STEP_VAL || 20000;
  const MIN_STEPS = 0;
  const STEPS_TICK_SIZE = MAX_STEPS < 100 ? 10 
  : MAX_STEPS <= 500 ? 50 
  : MAX_STEPS <= 1000 ? 100 
  : MAX_STEPS <= 5000 ? 500 
  : MAX_STEPS <= 10000 ? 1000
  : MAX_STEPS <= 20000 ? 2000 
  : MAX_STEPS <= 30000 ? 3000 
  : MAX_STEPS <= 40000 ? 4000 
  : MAX_STEPS <= 50000 ? 5000 
  : MAX_STEPS <= 60000 ? 6000 
  : 1000;
  const TICK_VALUES = Array(11).fill(0).map((e, i) => { return i * STEPS_TICK_SIZE });

  const x = d3
    .scaleBand()
    .domain(d3.utcDay.range(data[0].date, +data[data.length - 1].date + 1))
    .range([margin.left, width - margin.right])
    .padding(0.4);

  const y = d3
    .scaleLinear()
    .domain([MIN_STEPS, STEPS_TICK_SIZE * 10])
    .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g
      .attr('transform', `translate(0,${height - margin.bottom - 2})`)
      .call(
        d3
          .axisBottom(x)
          .tickValues(d3.utcDay.every(1).range(data[0].date, +data[data.length - 1].date + 1))
          .tickFormat((d) => moment(d).format('ddd DD'))
          .tickSize(0)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left - 10},0)`)
      .call(d3.axisLeft(y).tickValues(TICK_VALUES).tickSize(0).tickPadding(10))
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) => g.select('.domain').remove());

  const svg = d3.create('svg').attr('width', width).attr('height', height);
  
  svg.append('g').call(xAxis).selectAll('.tick text').call(wrap, x.bandwidth());

  svg.append('g').call(yAxis);
  
    const g = svg
    .append('g')
    .selectAll('g')
    .data(data)
    .join('g')
    .attr('transform', (d) => `translate(${x(d.date)},0)`);

  const emptyGroup = g.append('g').attr('visibility', (d) => {
    return d.empty ? 'visible' : 'hidden';
  });
  const emptyBar = emptyGroup
  .append('line')
  .attr('y1', (d) => y(TICK_VALUES[0]))
  .attr('y2', (d) => y(TICK_VALUES[TICK_VALUES.length - 1]))
  .attr('stroke-width', 36)
  .attr('stroke', EMPTY_COLOR)
  .attr('opacity', 0.07);

  const toAboveBar = (d) => d < STEPS_TICK_SIZE/2

  const stepsPointsGroup = g.append('g').attr('visibility', (d) => {
    return d.data ? 'visible' : 'hidden';
  });

  const stepBar = stepsPointsGroup
    .append('g')
    .attr('class', 'step-bar')
    .attr('transform', (d, i) => `translate(${(x.bandwidth() - BAR_WIDTH) / 2},0)`);  // Position the bar in the center

  stepBar.append('rect')
    .attr('x', 0)
    .attr('y', (d) => y(d.data))
    .attr('width', BAR_WIDTH)
    .attr('height', (d) => {
      if (!d.data) return 0;
      return y(MIN_STEPS) - y(d.data);
    })
    .attr('rx', 3)
    .attr('fill', STEPS_AREA_COLOR)
    .attr('stroke', 'none');

  stepBar.append('text')
    .attr('x', BAR_WIDTH / 2) // Position the text in the center of the bar
    .attr('y', (d) => toAboveBar(d.data) ? y(d.data) - 5 : y(d.data) + 15 )
    .attr('text-anchor', 'middle')
    .style('font-size', '10px')
    .attr('fill', (d) => toAboveBar(d.data) ? 'gray' : '#fff' )
    .text((d) => d.data);

  const xAxisLabelDate = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Date');

  const xAxisLabelDay = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 33)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Day');

  const yAxisLabelDate = svg
    .append('text')
    .attr('x', 0)
    .attr('y', margin.top - 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('steps');

  const gLegend = svg.append('g').attr('transform', (d) => `translate(500,${margin.top - 15})`);

  return svg.node();
};